import React, { useState } from 'react';
import { axiosInstance } from '../context/AuthContext';
import logo from '../components/logo.png';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState({ type: '', text: '' });
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const response = await axiosInstance.post('/auth/forgot-password', { email });
      setMessage({
        type: 'success',
        text: response.data.message || 'If an account exists, a reset link has been sent.',
      });
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Failed to send reset link';
      setMessage({ type: 'error', text: errorMessage });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex justify-center h-max bgDark grid grid-cols-12">
      <div className="col-span-4">
        <div className="flex flex-col items-left pl-10 justify-start h-screen bg-stone-100 shadow-md">
          <div className="grid">
            <div>
              <img src={logo} alt="logo" className="w-36" />
              <div className="flex w-max">
                <div className="text-4xl bodyFont">
                  <span className="text-emerald-500 tracking-tighter font-medium">Reset your password</span>
                </div>
              </div>

              <div className="py-6 text-lg font-bold">
                <span>Remembered your password? </span>
                <span className="text-blue-600"><a href="/login">Log in.</a></span>
              </div>

              <div className="grid w-80 grid-cols-2 gap-2">
                <div className="w-80 my-0">
                  <form className="login text-sm" onSubmit={handleSubmit}>
                    <div className="mb-6">
                      <label htmlFor="email" className="block dark font-medium">Email Address</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                        className="w-full px-3 py-2 border border-gray-300 rounded bg-logo focus:outline-none focus:border-emerald-300"
                        required
                      />
                    </div>

                    {message.text && (
                      <div className={`text-sm mb-4 ${message.type === 'success' ? 'text-green-600' : 'text-red-600'}`}>
                        {message.text}
                      </div>
                    )}

                    <button
                      disabled={isLoading}
                      type="submit"
                      className="w-40 bg-blue-600 hover:bg-emerald-500 text-white font-semibold py-2 rounded focus:outline-none focus:ring focus:ring-blue-300"
                    >
                      {isLoading ? 'Sending...' : 'Send reset link'}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div className="col-span-8 bg-cover bg-center h-screen flex flex-col justify-between bg-white">
        <div className="self-start pl-12 text-cyan-800">
          <h3 className="font-semibold tracking-tight headFont pt-20 text-4xl">Artization V1.0 is here</h3>
          <p className="w-72 pt-4 headFont">
            Use the power of AI to retrieve analytics on your art.
            See the data of facial responses to your work, in real-time.
          </p>

          <a href="/about"><button className="pt-4 border-b ease-in-out duration-300 hover:tracking-wider font-medium"> Learn More &rarr;</button></a>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
